<script>
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import API from '@/api.js';

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Resend activation",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: "",
      submitted: false,
      resendSuccess: false,
      error: null,
      status: 'ASK_RESEND',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    // Try to register the user in with the email, fullname
    // and password they provided.
    async tryToResend() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        try {
          this.status = 'ASKING';
          const resp = await this.axios.post(
            API.resendActivation.path(),
            {
              "email": this.email
            }
          );
          if (resp.status === 204) {
            // this.$router.push('/login');
            this.status = 'RESEND_SUCCESS';
          } else {
            this.status = 'RESEND_FAIL';
          }
        } catch (e) {
          console.log(e);
          this.status = 'RESEND_FAIL';
        }
      }
    },
    retry() {
        this.status = 'ASK_RESEND';
    }
  },
  mounted() {
    // if (this.$auth.check()) {
    //   this.$router.push('/');
    // }
  }
};
</script>

<template>
  <div class="container-fluid" style="overflow-x: hidden;">
    <div class="row" style="min-height: 100vh;">
      <div class="col-lg-5 login-side-col bg-primary">
        <div class="row h-100">
          <div class="col-12 align-self-center">
            <img class="my-auto align-self-center" :src="require('@/assets/images/logo-ae-w-alt.png')" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 align-self-center h-100 text-center" v-if="status==='ASKING'">
                <div class="lds-dual-ring"></div>
      </div>
      <div class="col-lg-7 align-self-center h-100" v-else>
          <div clas="row justify-items-center">
            <div class="col-6 mx-auto">
              <div class="text-center mt-2 align-self-center">
                  <h3 class="text-primary">Richiedi un nuovo link di attivazione</h3>
                  <p class="text-muted" v-if="status==='ASK_RESEND'">
                    Inserisci l'e-mail associata al tuo account Adapta Easy e riceverai un link di attivazione
                  </p>
                </div>
            </div>
            <div class="col-lg-8 col-md-10 col-12 mx-auto align-self-center">
              <div class="p-2 mt-4">
                    <div
                      class="alert alert-info text-left mb-4"
                      role="alert"
                      v-if="status==='RESEND_SUCCESS'"
                    >
                      Abbiamo inviato una mail con il link per attivare il tuo account all'indirizzo: <b>{{ email }}</b> <br/>
                    </div>
                    <div
                      class="alert alert-info text-left mb-4"
                      role="alert"
                      v-else-if="status==='RESEND_FAIL'"
                    >
                      Si è verificato un errore. Assicurati che l'indirizzo <b>{{ email }}</b> sia associato ad un account Adapta Easy Manager e che l'account non sia già attivo <br/>
                    </div>

                    <div class="my-4 text-center w-100" v-if="status==='RESEND_SUCCESS'">
                      <router-link class="btn btn-primary" to="/login">Torna alla pagina di login</router-link>
                    </div>
                    <div class="my-4 text-center w-100" v-else-if="status==='RESEND_FAIL'">
                      <button @click="retry()" class="btn btn-primary" to="/login">Riprova</button>
                      <router-link class="btn btn-outline-primary" to="/login">Torna alla pagina di login</router-link>
                    </div>
                    <form @submit.prevent="tryToResend" v-if="status==='ASK_RESEND'">
                      <div class="mb-3">
                        <label for="useremail">Indirizzo E-mail</label>
                        <input
                          type="email"
                          v-model="email"
                          class="form-control"
                          id="useremail"
                          placeholder="Inserisci l'indirizzo e-mail"
                          :class="{
                            'is-invalid': submitted && $v.email.$error,
                          }"
                        />
                        <div
                          v-if="submitted && $v.email.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.email.required"
                            >Campo obbligatiorio</span
                          >
                          <span v-if="!$v.email.email"
                            >Indirizzo e-mail non valido</span
                          >
                        </div>
                      </div>
                      <div class="row mb-0">
                        <div class="col-12 text-center">
                          <button class="btn btn-primary w-sm" type="submit">
                            Ottieni un nuovo link
                          </button> &nbsp; &nbsp;
                          <router-link to="/login" class="btn btn-outline-primary">
                            Torna al login
                          </router-link>
                        </div>
                      </div>
                      <!-- <div class="mt-4 text-center">
                        <p class="mb-0">
                          Ricordi la tua password ?
                          <router-link
                            to="/login"
                            class="fw-medium text-primary"
                            >Vai al Login</router-link
                          >
                        </p>
                      </div> -->
                    </form>
                  </div>
            </div>
            <div class="col-12 align-self-end">
              <p class="mt-5 text-center">
                © {{ new Date().getFullYear() }} - Powered by Vysio s.r.l. <br/> P.IVA: IT05156040759 - Via Carlo Magno 17 73042 Casarano (Le) Italia
              </p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<style>
.bg-login {
  background-color: #171f36;  
}
.login-side-col {
  text-align: center;
}
.login-side-col img {
    width: 40%;
}
</style>
